import { Button, Grid2 } from "@mui/material";
import Container from "@mui/material/Container";
import { makeStyles } from "@mui/styles";
import FullScreenModal from "components/common/FullScreenModal";
import React, { cloneElement, useRef } from "react";

const FormDialog = ({ handleClose, openForm, formText, editMode, maxWidth = "md", formComponent }) => {
    const classes = useStyles();
    const submitHandlerRef = useRef();

    function submit(e) {
        submitHandlerRef.current.submit(e);
    }

    const newFormComponent = cloneElement(formComponent, { submitHandlerRef: submitHandlerRef, editMode: editMode });
    const btnsModal = <>
        <Button variant="contained" color="secondary" className={classes.dialogSaveButton} onClick={submit}>
            Save
        </Button>
    </>;
    const title=  editMode ? "Edit" : "Add" + " " + formText;
    return (
        <>
            <FullScreenModal btns={btnsModal} title={title} handleClose={handleClose} open={openForm}>
                <Container maxWidth={maxWidth}>
                    <Grid2 sx={{ paddingTop: 10, paddingBottom: 35 }} size={12}>
                        {newFormComponent}
                    </Grid2>
                </Container>
            </FullScreenModal>
        </>
    );
};

export const useStyles = makeStyles(() => ({
    dialogSaveButton: {
        float: "right",
    },
    dialogActionSection: {
        paddingBottom: 30,
    },
}));

export default FormDialog;
